import { clsx } from "clsx";
import { CircleAlert, CircleCheck, X } from "lucide-react";
import { Toast } from "radix-ui";
import { useStore } from "zustand";

import styles from "./Toaster.module.css";
import { dismissToast, toastStore } from "./toast-store";

/** Renders every toast in the store. Mounted once, at the root. */
export function Toaster() {
  const toasts = useStore(toastStore, (state) => state.toasts);

  return (
    <Toast.Provider swipeDirection="right" duration={5000}>
      {toasts.map((item) => (
        <Toast.Root
          key={item.id}
          className={clsx(styles.toast, styles[item.tone])}
          onOpenChange={(open) => {
            if (!open) dismissToast(item.id);
          }}
          type={item.tone === "error" ? "foreground" : "background"}
        >
          {item.tone === "error" && <CircleAlert className={styles.icon} aria-hidden />}
          {item.tone === "success" && <CircleCheck className={styles.icon} aria-hidden />}
          <div className={styles.body}>
            <Toast.Title className={styles.title}>{item.title}</Toast.Title>
            {item.description && (
              <Toast.Description className={styles.description}>
                {item.description}
              </Toast.Description>
            )}
          </div>
          {item.action && (
            <Toast.Action asChild altText={item.action.label}>
              <button type="button" className={styles.action} onClick={item.action.onClick}>
                {item.action.label}
              </button>
            </Toast.Action>
          )}
          <Toast.Close className={styles.close} aria-label="Dismiss">
            <X />
          </Toast.Close>
        </Toast.Root>
      ))}
      <Toast.Viewport className={styles.viewport} />
    </Toast.Provider>
  );
}
